import { render, staticRenderFns } from "./PhoneUSA.vue?vue&type=template&id=a1e69e4e&scoped=true"
import script from "./PhoneUSA.vue?vue&type=script&lang=js"
export * from "./PhoneUSA.vue?vue&type=script&lang=js"
import style0 from "./PhoneUSA.vue?vue&type=style&index=0&id=a1e69e4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e69e4e",
  null
  
)

export default component.exports